import { useState } from "react";
import { Button, ConfigProvider, Flex, Input, Table, Tabs, theme } from "antd";
import MenuActions from "../../../../../../../../atom/MenuActions";

import StyledContainer from "./style";

import { isWindowReadonly } from "../../../../../advisor/helper";
import { isOrganizationBx } from "../../../../../../../../utils/helper/specialized";

import { SearchOutlined } from "@ant-design/icons";
import builder_template from "../../image/builder_template.png";
import builder_models from "../../image/builder_models.png";
import builder_scratch from "../../image/builder_scratch.png";
import { ReactComponent as IconTemplate } from "../../image/icon_template.svg";
import { ReactComponent as IconScratch } from "../../image/icon_scratch.svg";
import { ReactComponent as IconSaved } from "../../image/icon_saved.svg";

const SectionHome = ({
  activeTab,
  handleActionArchive,
  handleActionDuplicate,
  handleActionRename,
  listModels,
  listTemplates,
  loading,
  onClickStartFromScratch,
  onClickStartWithTemplate,
  onClickModelName,
  onTabChange,
  organization,
  setActiveTab,
  viewAdvisor,
  userEmail,
}) => {
  const { token } = theme.useToken();
  const [searchedText, setSearchedText] = useState("");

  const columns = [
    {
      filteredValue: [searchedText],
      onFilter: (value, record) =>
        String(record.name).toLowerCase().includes(value.toLowerCase()),
      render: allValues => (
        <a
          onClick={() =>
            onClickModelName({
              modelId: allValues._id,
            })
          }
        >
          {allValues.Name}
        </a>
      ),
      sorter: (a, b) => `${a.name}`.localeCompare(`${b.name}`),
      title: "Name",
      width: "33%",
    },
    {
      className: "cell-accent",
      render: allValues => allValues.RiskType,
      title: "Risk Type",
      width: "33%",
    },
    {
      render: allValues => allValues.PlanningObjective,
      title: "Planning Objective",
      width: "33%",
    },
    {
      className: "actions-menu-table-cell",
      key: "actions",
      render: allValues => (
        <MenuActions
          items={[
            {
              disabled: isWindowReadonly(),
              hidden: viewAdvisor && allValues.creator !== userEmail,
              key: "rename",
              label: "Rename",
              onClick: () => handleActionRename(allValues._id),
            },
            {
              disabled: isWindowReadonly(),
              key: "duplicate",
              label: "Duplicate",
              onClick: () => handleActionDuplicate(allValues._id),
            },
            {
              disabled: isWindowReadonly(),
              hidden: viewAdvisor && allValues.creator !== userEmail,
              key: "archive",
              label: "Archive",
              onClick: () => handleActionArchive(allValues._id),
            },
          ].filter(it => !it.hidden)}
        />
      ),
      width: 40,
    },
  ];

  const tabItems = [
    {
      children: (
        <Table
          columns={columns}
          dataSource={listModels?.filter(it => it.Type !== "Index")}
          loading={loading}
          pagination={false}
          rowHoverable={false}
        />
      ),
      key: "savedModels",
      label: (
        <Flex align="center" gap={10}>
          <IconScratch /> Saved Models
        </Flex>
      ),
    },
    {
      children: (
        <Table
          columns={columns.filter(it =>
            viewAdvisor ? it.key !== "actions" : it
          )}
          dataSource={listTemplates}
          loading={loading}
          pagination={false}
          rowHoverable={false}
        />
      ),
      disabled: isOrganizationBx(organization),
      key: "modelTemplates",
      label: (
        <Flex align="center" gap={10}>
          <IconSaved /> Model Templates
        </Flex>
      ),
    },
  ];

  return (
    <StyledContainer token={token}>
      <div className="container-content">
        <header>
          <div className="card-action">
            <Flex gap={24} justify="space-between" vertical>
              <Flex gap={2} vertical>
                <p>Start with a</p>
                <h4>Template</h4>
              </Flex>
              <Button
                disabled={isOrganizationBx(organization)}
                icon={<IconTemplate />}
                onClick={onClickStartWithTemplate}
              >
                All Templates
              </Button>
            </Flex>

            <img alt="builder template" src={builder_template} />
          </div>

          <div className="card-action">
            <Flex gap={24} justify="space-between" vertical>
              <Flex gap={2} vertical>
                <p>Start from</p>
                <h4>Scratch</h4>
              </Flex>
              <Button icon={<IconScratch />} onClick={onClickStartFromScratch}>
                Build Your Own
              </Button>
            </Flex>

            <img alt="builder scratch" src={builder_scratch} />
          </div>

          <div className="card-action">
            <Flex gap={24} justify="space-between" vertical>
              <Flex gap={2} vertical>
                <p>Continue with</p>
                <h4>Saved Models</h4>
              </Flex>
              <Button
                disabled={activeTab === "savedModels"}
                icon={<IconSaved />}
                onClick={() => setActiveTab("savedModels")}
              >
                Saved Models
              </Button>
            </Flex>

            <img alt="builder models" src={builder_models} />
          </div>
        </header>

        <main>
          <ConfigProvider
            theme={{
              components: {
                Table: {
                  headerBg: "#fff",
                  headerColor: "1E1919",
                  headerSplitColor: "transparent",
                },
              },
            }}
          >
            <Tabs
              activeKey={activeTab}
              onChange={onTabChange}
              tabBarExtraContent={
                <Input
                  onChange={event => setSearchedText(event.target.value)}
                  placeholder="Search..."
                  style={{
                    maxWidth: 200,
                    height: 36,
                    borderRadius: 25,
                  }}
                  suffix={<SearchOutlined />}
                />
              }
              items={tabItems}
            />
          </ConfigProvider>
        </main>
      </div>
    </StyledContainer>
  );
};

export default SectionHome;
